<div id="ok-message-modal">
  <div mat-dialog-title class="dialog-title" id="okTitle">{{ data.title | translate:locale.language }}</div>
  <div mat-dialog-content>
    <div class="modal-message" [innerHTML]="data.message | translate:locale.language"></div>
  </div>
  <div mat-dialog-actions class="button-row right">
    <button mat-button color="primary" id="ok" mat-dialog-close>{{ (data.ok || 'OK') | translate:locale.language }}</button>
  </div>
</div>